import React from 'react';
import CustomColorChip from '../../CustomColorChip';
import type { SubTakeData } from '../../RecordingSessionDataGrid/types';

type Props = {
    data: SubTakeData
    loading: boolean
    onClick?: (takeId: string) => void
    color?: string
}

export default function TakeChip({ data, loading, onClick, color }: Props) {
    if (!data) return null;

    return (
        <CustomColorChip
            label={data.subTake}
            onClick={() => onClick && onClick(data.id!)}
            disabled={loading}
            overrideColor={color}
            sx={{ ml: .5 }}
        />
    )
}